/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export function mapTaggedChange(input, change) {
    return { ...input, change };
}
export function tagChange(change, revision) {
    return { revision, change };
}
export function tagRollbackInverse(inverseChange, revision, rollbackOf) {
    return {
        revision,
        change: inverseChange,
        rollbackOf,
    };
}
export function makeAnonChange(change) {
    return { revision: undefined, change };
}
export var FinalChangeStatus;
(function (FinalChangeStatus) {
    FinalChangeStatus[FinalChangeStatus["conflicted"] = 0] = "conflicted";
    FinalChangeStatus[FinalChangeStatus["rebased"] = 1] = "rebased";
    FinalChangeStatus[FinalChangeStatus["commuted"] = 2] = "commuted";
})(FinalChangeStatus || (FinalChangeStatus = {}));
//# sourceMappingURL=changeRebaser.js.map